function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "#FFF",
  d: "M29.35 4.3c-9.25.85-16.45 8.6-16.45 18.05V49.6c0 1.65 1.35 3.05 3.05 3.05H46.2c1.65 0 3.05-1.35 3.05-3.05V22.35C49.25 12.9 42 5.15 32.8 4.3"
}), React.createElement("path", {
  fill: "#C7D7E2",
  d: "M32.7 4.3h-3.4c-.7.05-1.4.15-2.05.3 8.2 1.75 15.4 9 15.4 17.75V49.6c0 1.65-1.35 3.05-3.05 3.05h6.5c1.65 0 3.05-1.35 3.05-3.05V22.35c0-9.45-7.2-17.2-16.45-18.05z"
}), React.createElement("path", {
  fill: "#98BED8",
  d: "M31 13.6a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M27.25 22.6c-.85 0-1.5-.65-1.5-1.5 0-2.9 2.35-5.3 5.3-5.3.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5c-1.25 0-2.3 1-2.3 2.3 0 .85-.7 1.5-1.5 1.5zM3.8 41.6a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M46.15 54H15.9c-2.5 0-4.55-2.05-4.55-4.55v-27.2c0-8.05 4.8-15.2 12.3-18.2 2.2-.9 4.7-1.35 7.3-1.35h.1c2.65 0 5.1.45 7.3 1.35 7.45 3 12.3 10.15 12.3 18.2V49.5c0 2.45-2 4.5-4.5 4.5zM30.95 5.7c-2.25 0-4.35.4-6.2 1.15-6.3 2.55-10.4 8.6-10.4 15.45v27.25c0 .85.7 1.55 1.55 1.55h30.25c.85 0 1.5-.7 1.5-1.55v-27.3c0-6.8-4.1-12.9-10.4-15.45-1.85-.75-3.95-1.15-6.2-1.15h-.1v.05z"
}), React.createElement("path", {
  fill: "#C7D7E2",
  d: "M46.15 49c-.9 0-1.55-.65-1.55-1.5s.65-1.5 1.5-1.5 1.5.65 1.5 1.5-.65 1.5-1.45 1.5zm-4.55 0h-.05c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h.05c.85 0 1.5.65 1.5 1.5s-.7 1.5-1.5 1.5zm-4.55 0c-.9 0-1.55-.65-1.55-1.5S36.15 46 37 46s1.5.65 1.5 1.5-.65 1.5-1.45 1.5zm-4.55 0h-.05c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h.05c.85 0 1.5.65 1.5 1.5s-.7 1.5-1.5 1.5zm-4.55 0c-.9 0-1.55-.65-1.55-1.5s.65-1.5 1.5-1.5 1.5.65 1.5 1.5-.65 1.5-1.45 1.5zm-4.55 0c-.9 0-1.55-.65-1.55-1.5s.65-1.5 1.5-1.5 1.5.65 1.5 1.5S24.2 49 23.4 49zm-4.55 0h-.05c-.85 0-1.5-.65-1.5-1.5s.65-1.5 1.5-1.5h.05c.85 0 1.5.65 1.5 1.5s-.7 1.5-1.5 1.5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M4 48.1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM11 59c-.85 0-1.5-.65-1.5-1.5 0-1.1-.9-2-2-2s-2 .9-2 2c0 .85-.65 1.5-1.5 1.5s-1.5-.65-1.5-1.5c0-2.75 2.25-5 5-5s5 2.25 5 5c0 .85-.65 1.5-1.5 1.5z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M12.9 29.05a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M12.9 35.55c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 54.6c-.6 0-1.15-.35-1.4-.95l-2.5-6.5c-.3-.75.1-1.65.85-1.95.8-.3 1.65.1 1.95.85l2.5 6.5c.3.75-.1 1.65-.85 1.95-.2.1-.35.1-.55.1z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M5.6 43.25c-.3 0-.55-.1-.85-.25-.7-.45-.9-1.4-.4-2.1l5.4-8.1c.45-.7 1.4-.9 2.1-.4.7.45.9 1.4.4 2.1L6.9 42.6c-.3.4-.8.65-1.3.65zM58 48.1c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM58 59c-.85 0-1.5-.65-1.5-1.5 0-1.1-.9-2-2-2s-2 .9-2 2c0 .85-.65 1.5-1.5 1.5s-1.5-.65-1.5-1.5c0-2.75 2.25-5 5-5s5 2.25 5 5c0 .85-.65 1.5-1.5 1.5z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M49.1 29.05a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M49.1 35.55c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM55 54.6c-.2 0-.35-.05-.55-.1-.75-.3-1.15-1.15-.85-1.95l2.5-6.5c.3-.75 1.15-1.15 1.95-.85.75.3 1.15 1.15.85 1.95l-2.5 6.5c-.25.6-.8.95-1.4.95z"
}), React.createElement("path", {
  fill: "#454B54",
  d: "M56.4 43.25c-.5 0-.95-.25-1.25-.65l-5.4-8.1c-.45-.7-.25-1.6.4-2.1.7-.45 1.6-.25 2.1.4l5.4 8.1c.45.7.25 1.6-.4 2.1-.3.15-.6.25-.85.25zM43.75 58.05L40.1 52.6H21.95L21 54h1.9c.85 0 1.5.65 1.5 1.5s-.65 1.5-1.5 1.5H19l-.7 1.05c-.25.4 0 .95.5.95h24.45c.45 0 .75-.55.5-.95zM31 5.8s-.05 0 0 0c-.85-.05-1.55-.7-1.5-1.55l.1-2.5c0-.85.75-1.5 1.55-1.45.85 0 1.5.7 1.45 1.55l-.1 2.5c0 .8-.7 1.45-1.5 1.45z"
}));

var SvgSmartRobot = function SvgSmartRobot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 62 59",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSmartRobot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smart-robot.182b5de6.svg";
export { ForwardRef as ReactComponent };